// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


/* 所有引用的值 必须要写明是干嘛的。不是很多比方引用组件，就在自己组件引用 */
import "babel-polyfill";
import Vue from "vue"
import app from './App.vue'
import router from './router/index.js'
import toroute from './router/toroute.js'
import Vuex from 'vuex'
import store from './vuex/store'
import $ from 'jquery'
import axios from 'axios';
import user from './vuex/user'
import Format from './app/time.js';
import Copy from './app/deep_copy.js';
import guid from './app/guid.js';
import './styles/public/public.less';
import Qs from 'qs';

import vuescroll from 'vue-scroll'
Vue.use(vuescroll)

//图片放大缩小
import Viewer from 'v-viewer'
require("viewerjs/dist/viewer.css")
Vue.use(Viewer)
Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

/* //自己写的日历插件
import calendardate from './apponeselfplug/calendardate/calendardate.js'
Vue.use(calendardate) */
//自己写的搜索插件
import search from './apponeselfplug/search/search.js'
Vue.use(search)

/* import iView from 'iview'
import 'iview/dist/styles/iview.css'    // 使用 CSS
Vue.use(iView) */

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);

window.jQuery = window.$ = require('jquery')

/*axios 请求编码 发布请求钱 发布请求以后*/
axios.interceptors.request.use((config) => {
    /* var aa =  store;

    store; */
    config.data = Qs.stringify(config.data);
    return config;
}, function (error) {
    return Promise.reject(error);
});
/*axios 请求编码 发布请求钱 发布请求以后*/
axios.interceptors.response.use((config) => {
    return config;
}, function (error) {
    return Promise.reject(error);
});


Vue.use(Vuex);
Vue.prototype.$user = user;
Vue.prototype.$http = axios;
Vue.prototype.$Copy = Copy;//深复制   this.$Copy.copy.copy("111");
Vue.prototype.$guid = guid;//生成唯一码  this.$guid.generateUUID();


let vm = new Vue()
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(app)
})

import echarts from 'echarts'
Vue.prototype.$echarts = echarts;
/*this.$http({
    method: 'post',
    url: "",
    data: {
    }
})
.then(function (success) {
}.bind(this))
.catch(function (response) {
    this.$Message.error('请求失败查询网络是否畅通！');
}.bind(this))*/



// WEBPACK FOOTER //
// ./src/main.js